import React from 'react'

const CreditNoteTableComponentLoadable = React.lazy(() => import('./CreditNoteRequestComponent/CreditNoteTableComponent'));
const FinanceApprovalTableComponentLoadable = React.lazy(() => import('./CreditNoteRequestComponent/FinanceApprovalTableComponent'));
const DirectorTableComponentLoadable = React.lazy(() => import('./CreditNoteRequestComponent/DirectorApprovalTableComponent'));
const ApprovalTableComponentLoadable = React.lazy(() => import('./CreditNoteRequestComponent/ApprovalTableComponent'));
export {
    CreditNoteTableComponentLoadable,
    FinanceApprovalTableComponentLoadable,
    ApprovalTableComponentLoadable,
    DirectorTableComponentLoadable
}